export const actionMap = {}

export const defaultState = {
    data: undefined,
    isLoading: false,
    flightDate: undefined
}

export default (reduxState = defaultState, action) => {
    if (action !== undefined && actionMap[action.type]) {
        return actionMap[action.type](reduxState, action)
    }
    return reduxState
}



// WEBPACK FOOTER //
// ./src/screens/flights/reducers/index.js